import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryColor,
  White,
  LightPrimaryColor,
  Black,
  InputColor,
  LightGrey,
  DarkGrey,
} from "../../../shared/styles/colors";

export default makeStyles(() => ({
  headerDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
      alignItems: "center",
    },
  },
  headerSubDiv: {
    display: "flex",
    flexDirection: "row",
    width: "8rem",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerSubDiv2: {
    display: "flex",
    flexDirection: "row",
    width: "15rem",
    alignItems: "center",
    justifyContent: "start",
  },
  title: {
    color: Black,
    fontSize: "1.3rem",
    fontWeight: "700",
  },
  subtitle: {
    color: DarkGrey,
    fontSize: "1rem",
  },
  form: {
    marginTop: "0%",
  },
  label: {
    fontWeight: "600",
  },
  headerButton: {
    width: "100%",
    textTransform: "none",
    border: "none",
    color: White,
    background: PrimaryColor,
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  container: {
    display: "flex",
    flexDirection: "row",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
    marginTop: "1.5rem",
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
  },
  inputGroup: {
    display: "flex",
    flexDirection: "row",
    width: "99% !important",
    alignItems: "center",
    padding: 0,
    "@media (max-width: 640px)": {
      //flexDirection: "column",
      width: "100% !important",
    },
  },
  input: {
    width: "95% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  textarea: {
    width: "95% !important",
    height: "auto",
    maxHeight: "10rem",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100% !important",
      maxHeight: "6rem",
    },
  },
  text: {
    color: DarkGrey,
    fontSize: "1rem",
  },
  buttonDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "5%",
  },
  button: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "12rem",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  //Details
  inputDiv: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
  },
  inputDetail: {
    width: "95% !important",
    border: "none",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    background: LightGrey,
    color: InputColor,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
      color: InputColor,
    },
  },
  bigTitle: {
    color: Black,
    fontSize: "2rem",
    fontWeight: "700",
    marginTop: "2rem",
    marginBottom: "2rem",
    "@media (max-width: 640px)": {
      fontSize: "1.5rem",
    },
  },
  rating: {
    display: "flex",
    alignItems: "center",
    "& span": {
      fontSize: "1.5rem",
    },
  },
  filledStar: {
    color: "#CBCF00", // gold color for filled stars
  },
  emptyStar: {
    color: "#C0C0C0", // silver color for empty stars
  },
  icon: {
    marginLeft: "1px",
  },
  button2: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "auto",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:disabled": {
      color: White,
      cursor: "none",
    },
  },
  detailDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: "1rem",
    "@media (max-width: 640px)": {
      flexDirection: "column",
    },
  },
  detailSubDiv: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    justifyContent: "start",
    alignItems: "start",
    "@media (max-width: 640px)": {
      width: "100%",
      justifyContent: "start",
      alignItems: "start",
    },
  },
  detailSubDiv2: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "start",
    alignItems: "center",
    "@media (max-width: 640px)": {
      flexDirection: "column",
    },
  },
}));
